import { ADD_COLOR }   from '../actions/actionTypes'

const colors = ( state = [], action ) => {
	switch(action.type){
		case ADD_COLOR:
			 return [
				 ...state,
				 action.color
			 ]
		default:
			return state;
	}
}

export default colors;


// WEBPACK FOOTER //
// ./src/reducers/colors.js